<div
	class="advanced-filter-wrapper"
	[ngClass]="{
		'advanced-filter-wrapper': 1 == 1,
		'wrapper-padding': layoutService.screenSize > ScreenSize.MOBILE_L
	}">
	<app-device-status-filter [hidden]="deviceFilter != 'Status'"></app-device-status-filter>
	<app-device-bundle-filter [hidden]="deviceFilter != 'Bundle'"></app-device-bundle-filter>
	<app-terminal-filter [hidden]="deviceFilter != 'Terminal'"></app-terminal-filter>
	<app-merchants-filter [hidden]="deviceFilter != 'Merchants'"></app-merchants-filter>

	<div class="btn-section">
		<button
			class="btn primary-btn"
			(click)="search()"
			>FILTER</button
		>
	</div>
</div>
